<template>
<div class="aup-public-profile__personal-info-wrapper"
        :style="{ 'top': heroPosition(), maxWidth: '100%' }">

    <div>
        <div class="d-flex flex-column flex-lg-row align-items-center mb-2 position-relative pt-12 pt-md-0"
		 :class="{ 'mb-5' : isBlankProfile }">

            <div
                class="aup-public-profile__avatar"
                :style="{'background-image' : respMediaBackgroundImage(ava.ppd_imageurl, ava.ppd_zestyguid, 200) }"
                role="img"
                :aria-label="`Profile photo of ${name}`"
            ></div>
            <div class="ml-lg-4">
				<!-- PHOTOGRAPHER TYPE  -->
				<div class="aup-public-profile__photographytype d-flex mb-1">
					<BaseTextLabel class="" v-for="(item, index) in type" :key="index" :text="item" :rounded="false" :uppercase="false" color="black" :bold="false"/>
				</div>
                <div class="d-flex align-items-center justify-content-between">
                    <h2 class="aup-public-profile__name text-white t-heavy mb-0 mx-auto mx-lg-0 mb-lg-2 t-shadow d-flex align-items-center" style="max-width: 600px">error:call:0</h2>
					<!-- REPORT USER ICON : DESKTOP -->
					<div class="aup-public-profile__report-icon-container d-none d-lg-block" v-if="!isSelfProfile && loggedIn">
						<div
							role="button"
							class="aup-public-profile__report-button d-inline-flex"
							@click="openReportModal()"
						>
							<IconReportDots />
							<div class="aup-public-profile__tooltip__container d-flex" v-if="!isSelfProfile && loggedIn">
								<p class="aup-public-profile__tooltip t-micro t-heavy t-micro--regular">Report Profile</p>
							</div>
						</div>
					</div>
                </div>

				<!-- LOCATION  -->
                <div class="d-flex align-items-center flex-column flex-lg-row">
                    <p class="text-white t-shadow t-bold mb-0 my-2 my-md-0 mr-lg-4" v-if="state || country">
                        error:call:1<span v-if="state && country">,&nbsp;</span>
                        error:call:2
                    </p>
					<BaseLikeButton
                        :isSelf="isSelfProfile"
                        :likedContent="profileGUID"
                        :likeType="'profile'"
                        :profileView="true"
                        :loggedIn="loggedIn"
						textPlacement="right"
						:showCount="true"
						:showCountOnHover="false"
						:offsetTooltip="true"
					/>
					<!-- REPORT USER ICON : MOBILE -->
					<div class="aup-public-profile__report-icon-container d-lg-none lg-3" v-if="!isSelfProfile && loggedIn">
						<div
							role="button"
							class="aup-public-profile__report-button d-flex mt-1"
							@click="openReportModal()"
						>
							<IconReportDots />
							<div class="aup-public-profile__tooltip__container d-inline-flex" v-if="!isSelfProfile && loggedIn">
								<p class="aup-public-profile__tooltip t-micro t-heavy t-micro--regular p-1">Report Profile</p>
							</div>
						</div>
					</div>
                </div>
            </div>
        </div>

        <!--ROW OF BADGES-->
        <div class="my-4 d-flex flex-wrap flex-wrap-reverse aup-public-profile__badge-container justify-content-center justify-content-md-start" v-if="badgesStatical.length || badges.length">
			<div class="aup-badge mr-md-3 mb-3 mb-sm-0 mx-1 ml-md-0" v-if="badges" v-for="badgeEarned in badges" :key="badgeEarned.ppd_badgeid.ppd_badgename" :name="badgeEarned.ppd_badgename">
				<img
					class="image-responsive"
					:src="badgeEarned.ppd_badgeid.ppd_level1iconoverride"
					:alt="badgeEarned.ppd_badgeid.ppd_badgename"
				/>
			</div>
			<div class="aup-badge mr-md-3 mb-3 mb-sm-0 mx-1 ml-md-0" v-if="badgesStatical" v-for="badge in badgesStatical" :key="badge.ppd_badgename" :name="badge.ppd_name">
				<img
					class="image-responsive"
					:src="badge.ppd_level1iconoverride"
					:alt="badge.ppd_badgename"
				/>
			</div>
        </div>

        <!--MY STORY AND ICONS-->
        <div
            class="aup-public-profile__my-info row no-gutters"
            v-if="about || hasLinks || specialties.length"
        >
            <div class="align-items-center flex-column" :class="{'col-lg-6': hasLinks || specialties.length, 'col-md-8 col-xl-7 mx-auto': !(hasLinks || specialties.length)}" v-if="about">
                <div class="mb-lg-0 p-lg-5" :class="{'mb-4': (hasLinks || specialties.length)}">
                    <h4 class="t-small text-uppercase text-white mb-2">My Story</h4>
                    <p class="text-white mb-0 aup-public-profile__about">error:call:3</p>
                </div>
            </div>
            <div v-if="hasLinks || specialties.length" class="aup-public-profile__meta-container no-gutters" :class="{ 'col-lg-6': about, 'w-100': !about}">
                <div
                    class="aup-public-profile__meta d-flex h-100 p-lg-5" :class="{ 'row no-gutters': !about, 'flex-column': about }"
                >
                    <div
                        class="d-flex justify-content-between flex-column flex-md-row mb-4"
                        :class="{'col-lg-6 mb-lg-0': !about && specialties.length, 'mb-lg-5': about}"
                        v-if="hasLinks"
                    >
                        <!--SOCIAL ICONS ROW-->
                        <div class="d-flex align-items-center flex-column order-2 order-lg-1 w-100">
							<div class="aup-lined-text d-flex align-items-center w-100 mb-2 mb-md-0">
								<h4 class="t-small text-uppercase text-white mr-4 aup-lined-text__heading d-inline-block aup-public-profile__hero__subtext">Social</h4>
								<div
									class="aup-lined-text__line aup-lined-text__line--light d-block d-lg-none"
								></div>
							</div>
                            <!--TODO: ADD V FOR WHEN KNOW WHAT DATA TO LOOP OVER-->
							<div class="d-flex w-100">
								<a
									class="mr-3 d-flex align-self-center"
									v-if="instagramLink"
									:href="'https://instagram.com/' + stripOutDomain(instagramLink)"
									target="_blank"
									title="Share to Instagram"
								>
									<IconInstagram :hoverState="true" />
								</a>
                                <a
									class="mr-3 d-flex align-self-center"
									v-if="threadsLink"
									:href="'https://www.threads.net/' + stripOutDomain(threadsLink)"
									target="_blank"
									title="Share to Threads"
								>
									<IconThreads :hoverState="true" />
								</a>
								<a
									class="mr-3 d-flex align-self-center"
									v-if="twitterLink"
									:href="'https://twitter.com/' + stripOutDomain(twitterLink)"
									target="_blank"
									title="Share to Twitter"
								>
									<IconTwitter :hoverState="true" />
								</a>
								<a
									class="mr-3 d-flex align-self-center"
									v-if="facebookLink"
									:href="'https://facebook.com/' + stripOutDomain(facebookLink)"
									target="_blank"
									title="Share to Facebook"
								>
									<IconFacebook :hoverState="true" />
								</a>
								<a
									class="mr-3 d-flex align-self-center"
									v-if="youtubeLink"
									:href="'https://youtube.com/' + stripOutDomain(youtubeLink)"
									target="_blank"
									title="Share to YouTube"
								>
									<IconYouTube :hoverState="true" />
								</a>
                                <a
									class="mr-3 d-flex align-self-center"
									v-if="tiktokLink"
									:href="'https://tiktok.com/' + stripOutDomain(tiktokLink)"
									target="_blank"
									title="Share to TikTok"
								>
									<IconTikTok :hoverState="true" />
								</a>
								<a
									class="mr-3 d-flex align-self-center"
									v-if="portfolioLink"
									:href="addHttpToLink(portfolioLink)"
									target="_blank"
									title="Share"
								>
									<IconGlobe :hoverState="true" />
								</a>
							</div>
                        </div>
                    </div>
                    <!--WHAT I DO ROW-->
                    <div class="w-100" :class="{'col-lg-6 mb-lg-0': (!about && hasLinks)}" v-if="specialties.length">
                        <div class="aup-lined-text d-flex align-items-center w-100 mb-2 mb-md-0">
                            <h4 class="t-small text-uppercase text-white mr-4 aup-lined-text__heading aup-public-profile__hero__subtext">What i do</h4>
                            <div
                                class="aup-lined-text__line aup-lined-text__line--light d-block d-lg-none"
                            ></div>
                        </div>
                        <ul class="d-flex flex-wrap align-items-center p-0 mb-0">
                            <BaseTextLabel
                                v-for="(item, index) in specialties"
                                :key="index"
                                :text="item"
                                color="light"
                            />
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import BaseTextLabel from '@/components/global/BaseTextLabel';
import BaseBadge from '@/components/global/BaseBadge';
import { calcRespImageURLMixin } from '@/mixins/mixins.js';

export default {
    name: 'Hero',
    components: {
        BaseTextLabel,
        BaseBadge
	},
	mixins: [ calcRespImageURLMixin ],
    props: {
        heroBoxIsEmpty: {
            type: Boolean,
            default: false
        },
        isBlankProfile: {
            type: Boolean,
            default: false
        },
        avatar: {
            type: Object,
            required: true
        },
        name: {
            type: String,
            required: true,
            default: ''
        },
        country: {
            type: String,
            default: ''
        },
        instagramLink: {
            type: String,
            required: false,
            default: ''
        },
        twitterLink: {
            type: String,
            required: false,
            default: ''
        },
        facebookLink: {
            type: String,
            required: false,
            default: ''
        },
        youtubeLink: {
            type: String,
            required: false,
            default: ''
        },
        tiktokLink: {
            type: String,
            required: false,
            default: ''
        },
        threadsLink: {
            type: String,
            required: false,
            default: ''
        },
        portfolioLink: {
            type: String,
            required: false,
            default: ''
        },
        state: {
            type: String,
            default: ''
        },
        about: {
            type: String,
            default: ''
        },
        badges: {
            type: Array,
            default: () => []
        },
		badgesStatical: {
			type: Array,
			default: () => []
		},
        specialties: {
            type: Array,
            default: () => []
        },
        type: {
            type: Array,
            default: () => []
        },
		isSelfProfile: {
			type: Boolean,
			default: false
        },
        profileGUID: {
            type: String,
            default: ''
		},
		loggedIn: {
			type: Boolean,
			default: false
		},
		socialLinksPublic: {
			type: Boolean,
			default: false
		}
    },
    methods: {
		openReportModal() {
            this.$emit('show-report-modal', true);
        },
        stripOutDomain(string) {
			if (typeof string !== "string") {
				return "";
			}
            if (string.includes('.com')) {
                const newUrl = string.split('.com/');
                return newUrl[1];
            } else {
                return string;
            }
		},
		addHttpToLink(string) {
			// add https:// to URL if it doesnt include it

			if (typeof string !== "string") {
				return "";
			}

			if (string.includes('https://' || 'http://')) {
                return string;
            } else {
                return `https://${string}`;
            }
		},
        heroPosition() {
            if ( !this.heroBoxIsEmpty && this.isBlankProfile ) {
                return '-15px';
            } else if ( !this.heroBoxIsEmpty ) {
                return '-15px';
            } else {
                return '0px';
            }
        }
    },
    computed: {
        hasLinks() {
            return ( this.twitterLink || this.youtubeLink || this.instagramLink || this.portfolioLink || this.facebookLink || this.tiktokLink || this.threadsLink) && this.socialLinksPublic;
        },
		ava() {
        	console.log('ava', JSON.stringify(this.avatar))
        	return this.avatar
		}
    },
};
</script>

<style lang="scss">
@import '../../assets/scss/all';
.aup-public-profile {
    &__personal-info-wrapper {
        position: relative;
        flex-basis: 100%;
        @include media-breakpoint-down(md) {
            top: unset;
            padding-top: 0;
        }
	}
	&__name {
		&::after {
			content: "Beta";
			background-color: #E75300;
			color: white;
			border-radius: 2px;
			font-size: 10px;
			font-family: "SSTProRoman", Arial, Helvetica, sans-serif;
			padding: 2px 4px 3px;
			margin-left: 5px;
		}
	}

	&__hero {
		&__subtext {
			@include media-breakpoint-up(md) {
				margin-bottom: 14px !important;
			}
		}
	}
    &__my-info {
        background-color: $gray-800;
        // min-height: 240px;
        @include media-breakpoint-down(md) {
            padding-top: 32px;
            padding-bottom: 32px;
            padding-left: 5%;
            padding-right: 5%;
        }
    }

    &__about {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 13;
        overflow-wrap: break-word;
        overflow: hidden;
    }

    &__meta-container {
        @media (min-width: 992px) {
            border-left: 0.5px $gray-600 solid;
        }
    }
	&__badge-container {
        @include media-breakpoint-down(md) {
            padding-left: 5%;
            padding-right: 5%;
        }
	}
	&__report-icon-container {
        z-index: map-get($zindices, fixed);
        position: absolute;
		top: 40px;
		right: 0;
		cursor: pointer;
		@include media-breakpoint-down(md) {
			position: relative;
			top: auto;
			right: auto;
        }
    }
    &__report-button:hover {
        &
            .aup-public-profile__tooltip__container
            .aup-public-profile__tooltip {
            opacity: 1;
        }
		// dl : commenting out per design but leaving in case design changes mind
		// .icon__report-flag {
		// 	fill: $primary;
		// }
    }
    &__report-button {
        cursor: pointer;
		background-color: rgba($sony-black, 0.8);
		padding: 0.5rem 0.3rem;
		// position: relative;
		// top: 50%;
		// transform: translateY(-50%);
		&--mobile {
			cursor: pointer;
			position: relative;
		}
    }
	&__tooltip {
        opacity: 0;
        transition: opacity 0.3s ease-in;
        // bottom: 75px;
        // margin-left: -0.2rem;
        min-width: 100px;
        border-radius: 2px;
        background-color: $sony-white;
        color: $sony-black;
        text-align: center;
		padding: 0.25rem;
        &:before {
            content: '';
            position: absolute;
            border-style: solid;
            display: block;
            margin-top: -9px;
            margin-left: 75px;
            border-color: $sony-white transparent;
			border-width: 0 5px 5px;
			@include media-breakpoint-down(md) {
            	margin-left: 42px;
			}
        }
        &__container {
            z-index: map-get($zindices, fixed);
            position: absolute;
            bottom: -55px;
			right: 1%;
			@include media-breakpoint-down(md) {
				bottom: -50px;
				right: calc(50% - 50px);
			}
        }
    }
    &__photographytype {
		//  mb-2 mt-md-0 my-md-2
		margin-bottom: 0.5rem;
		// @include media-breakpoint-up(md) {
        //     margin-top:
        // }
        flex-wrap: wrap;
		justify-content: flex-start;
		@include media-breakpoint-down(md) {
            justify-content: center;
        }
    }
    &__avatar {
		// background-color: black;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        width: 100px;
        height: 100px;
		@include media-breakpoint-down(md) {
            width: 80px;
        	height: 80px;
        }
        border: 3px solid $white;
        border-radius: 50%;
    }
    &__svg {
        height: 20px;
        width: 20px;
        &--active {
            path {
                fill: $primary;
            }
            cursor: initial !important;
        }
    }
}
</style>
